import { useQuery } from '@tanstack/react-query';
import { api } from '../client';

export interface AuditEntry {
  id: number;
  event_at: number;
  user_id: number | null;
  user_display_name: string | null;
  action: string;
  entity_type: string | null;
  entity_id: number | null;
  old_values: Record<string, unknown> | null;
  new_values: Record<string, unknown> | null;
  ip_address: string | null;
  user_agent: string | null;
  request_id: string | null;
}

export interface AuditResponse {
  audit: AuditEntry[];
  next_cursor: number | null;
}

export interface AuditFilters {
  cursor?: number;
  limit?: number;
  user_id?: number;
  action?: string;
  entity_type?: string;
  entity_id?: number;
  since?: number;
  until?: number;
  request_id?: string;
}

export function useAuditLog(filters: AuditFilters = {}) {
  const params = new URLSearchParams();
  if (filters.cursor !== undefined) params.set('cursor', String(filters.cursor));
  if (filters.limit !== undefined) params.set('limit', String(filters.limit));
  if (filters.user_id !== undefined) params.set('user_id', String(filters.user_id));
  if (filters.action) params.set('action', filters.action);
  if (filters.entity_type) params.set('entity_type', filters.entity_type);
  if (filters.entity_id !== undefined) params.set('entity_id', String(filters.entity_id));
  if (filters.since !== undefined) params.set('since', String(filters.since));
  if (filters.until !== undefined) params.set('until', String(filters.until));
  if (filters.request_id) params.set('request_id', filters.request_id);
  const qs = params.toString();
  const url = qs.length > 0 ? `/api/audit?${qs}` : '/api/audit';
  return useQuery({
    queryKey: ['audit', { ...filters }],
    queryFn: ({ signal }) => api.get<AuditResponse>(url, signal),
  });
}
